import script from "./seller-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./seller-profile.vue?vue&type=script&setup=true&lang=js"

import "./seller-profile.vue?vue&type=style&index=0&id=1805f4d2&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1805f4d2"]])

export default __exports__